export default "__VITE_ASSET__mWo3Qr26__"